<template>
  <div class="home">
    <div class="section section-1">
      <div
        class="bg"
        v-lazy:background-image="
          '//doc.yctop.com/cdn/static/images/index-bg1.jpg'
        "
      ></div>
      <div class=" container">
        <div class="detail">
          <p class="title">{{ $t("home.title") }}</p>
          <p class="subtitle opacity50">{{ $t("home.subtitle") }}</p>
        </div>
        <div class="v3-index-menu">
          <el-tabs
            v-model="menuIndex"
            @tab-click="menuSelectHandler"
            :before-leave="beforeMenuSelectHandler"
          >
            <el-tab-pane
              label="International Air Freight"
              name="1"
              class="menu-pane-1"
            >
              <div class="menu-detail clearfix"></div>
              <div class="menu-detail">
                <AirportSelection
                  ref="departureSelection"
                  v-bind:prefix-label="'Port of Departure'"
                  v-bind:show-hot-import-city="false"
                  v-bind:default-airport="''"
                  v-bind:airport-d-b="airportDB"
                  v-bind:city-d-b="cityDB"
                  @update-airport="updateDeparture"
                  @tab="focusDestination"
                  @blur-notify="departureSelectionBlur"
                  v-bind:focus-state="departureSelectionFocusState"
                  key="departure"
                ></AirportSelection>
                <AirportSelection
                  ref="destinationSelection"
                  v-bind:prefix-label="'Port of Destination'"
                  v-bind:show-hot-import-city="true"
                  v-bind:default-airport="''"
                  v-bind:airport-d-b="airportDB"
                  v-bind:city-d-b="cityDB"
                  @update-airport="updateDestination"
                  @blur-notify="destinationSelectionBlur"
                  v-bind:focus-state="destinationSelectionFocusState"
                  key="destination"
                ></AirportSelection>
                <el-button
                  type="danger"
                  icon="el-icon-search"
                  @click="gotoProductionSearchPage"
                  >{{ $t("home.book") }}</el-button
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label name="2"></el-tab-pane>
            <el-tab-pane label="Cargo Tracking" name="3">
              <div class="menu-detail clearfix"></div>
              <div class="menu-detail">
                <el-input
                  placeholder="Where is the goods? Timely status? Enter the waybill number (eg: 99950346866)"
                  class="tl ipt-n"
                  v-model="orderNo"
                ></el-input>
                <el-button
                  type="danger"
                  icon="el-icon-search"
                  @click="gotoTrailPage"
                  >{{ $t("header.menu.track") }}</el-button
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="section section-2" id="section-2">
      <div
        class="bg"
        v-lazy:background-image="
          '//doc.yctop.com/cdn/static/images/index-bg2.jpg'
        "
      ></div>
      <div class="container">
        <div class="detail">
          <p class="title">{{ $t("home.transport.title") }}</p>
          <p class="subtitle tc">{{ $t("home.transport.subtitle") }}</p>
        </div>
        <el-row class="card-container">
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div
                class="c-icon el-icon-eft-zhinengdingcang-youcang iconfont"
              ></div>
              <div class="title tc">{{ $t("home.transport.p1") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span1") }}</div>
            </el-card>
          </el-col>
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div
                class="c-icon el-icon-eft-shangmenlanhuo-youcang iconfont"
              ></div>
              <div class="title tc">{{ $t("home.transport.p2") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span2") }}</div>
            </el-card>
          </el-col>
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div
                class="c-icon el-icon-eft-quanguobaoguan-youcang iconfont"
              ></div>
              <div class="title tc">{{ $t("home.transport.p3") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span3") }}</div>
            </el-card>
          </el-col>
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div class="c-icon el-icon-eft-cangchuneizhuang iconfont"></div>
              <div class="title tc">{{ $t("home.transport.p4") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span4") }}</div>
            </el-card>
          </el-col>
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div class="c-icon el-icon-eft-haiwaiwuliu iconfont"></div>
              <div class="title tc">{{ $t("home.transport.p5") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span5") }}</div>
            </el-card>
          </el-col>
          <el-col :span="4" class="card">
            <el-card shadow="hover">
              <div class="c-icon el-icon-eft-baoxianlipei iconfont"></div>
              <div class="title tc">{{ $t("home.transport.p6") }}</div>
              <div class="subtitle tc">{{ $t("home.transport.span6") }}</div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section section-3" id="section-3">
      <div class="container clearfix">
        <el-row>
          <el-col :span="11">
            <p class="title mt100">{{ $t("home.reliable.title") }}</p>
            <p class="subtitle">{{ $t("home.reliable.p") }}</p>
            <el-button type="primary" @click="gotoFlightListPage()">{{ $t("home.book") }}</el-button>
          </el-col>
          <el-col :span="13">
            <div
              class="bg"
              v-lazy:background-image="
                '//doc.yctop.com/cdn/static/images/index-bg3.jpg'
              "
            ></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section section-4" id="section-4">
      <div
        class="bg"
        v-lazy:background-image="
          '//doc.yctop.com/cdn/static/images/index-bg4.jpg'
        "
      ></div>
      <div class="container">
        <div class="detail">
          <p class="title">{{ $t("home.booking.title") }}</p>
          <p class="subtitle tc">{{ $t("home.booking.p") }}</p>
        </div>
        <div class="image-container">
          <div
            class="bg1 fl"
            v-lazy:background-image="
              '//doc.yctop.com/cdn/static/images/index-image1.png'
            "
          ></div>
          <div
            class="bg2 fl"
            v-lazy:background-image="
              '//doc.yctop.com/cdn/static/images/index-image2.png'
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="section section-5" id="section-5">
      <div
        class="bg"
        v-lazy:background-image="
          '//doc.yctop.com/cdn/static/images/index-bg5.jpg'
        "
      ></div>
      <div class="container">
        <div class="detail">
          <p class="title">{{ $t("home.check.title") }}</p>
          <p class="subtitle tc">{{ $t("home.check.p") }}</p>
        </div>
        <div class="image-container">
          <div
            class="bg1 fl"
            v-lazy:background-image="
              '//doc.yctop.com/cdn/static/images/index-image3.png'
            "
          ></div>
          <div
            class="bg2 fl"
            v-lazy:background-image="
              '//doc.yctop.com/cdn/static/images/index-image4.png'
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="section section-6" id="section-6">
      <div class="container clearfix">
        <el-row>
          <el-col :span="12">
            <div
              class="bg"
              v-lazy:background-image="
                '//doc.yctop.com/cdn/static/images/index-image5.jpg'
              "
            ></div>
          </el-col>
          <el-col :span="12">
            <p class="title mt200">{{ $t("home.team.title") }}</p>
            <p class="subtitle">{{ $t("home.team.p") }}</p>
            <el-button type="primary" @click="gotoServicePage">{{
              $t("home.team.btn")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section section-6" id="section-6">
      <div class="container">
        <div class="contactUS">
          <h4>{{ $t("home.contacts.title") }}</h4>
          <div class="line"></div>
          <div class="tel_cont">
            <div class="cont2">
              <div class="row row1">
                <i class="iconfont el-icon-eft-user"></i>
                <span class="area">{{ $t("home.contacts.north") }}</span>
                <span>{{ $t("home.contacts.northPerson") }}</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dianhua"></i>
                <span class="num">13801156585</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-youxiang1"></i>
                <span>zhaofuqi@cngdf.com</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dingwei1"></i>
                <span class="address">{{
                  $t("home.contacts.northAddress")
                }}</span>
              </div>
            </div>
            <div class="cont2 east">
              <div class="row row1">
                <i class="iconfont el-icon-eft-user"></i>
                <span class="area">{{ $t("home.contacts.east") }}</span>
                <span>{{ $t("home.contacts.eastPerson") }}</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dianhua"></i>
                <span class="num">13816967707</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-youxiang1"></i>
                <span>dingwh@yctop.com.cn</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dingwei1"></i>
                <span class="address">{{
                  $t("home.contacts.eastAddress")
                }}</span>
              </div>
            </div>
            <div class="cont2">
              <div class="row row1">
                <i class="iconfont el-icon-eft-user"></i>
                <span class="area">{{ $t("home.contacts.south") }}</span>
                <span>{{ $t("home.contacts.southPerson") }}</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dianhua"></i>
                <span class="num">13602820917</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-youxiang1"></i>
                <span>ming_feng@yctop.com</span>
              </div>
              <div class="row">
                <i class="iconfont el-icon-eft-dingwei1"></i>
                <span class="address">{{
                  $t("home.contacts.southAddress")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-card class="popBar">
      <el-row class="main">
        <template v-for="(item, index) of popBarDataSource">
          <el-col :span="4" class="tc" v-if="item.type == 'PRODUCT'">
            <router-link :to="item.url">
              <div class="title">
                <div>{{ item.content.departure }}</div>
                <div class="middle_cont">
                  <span class="iconfont el-icon-eft-feiji800"></span>
                  <div class="line"></div>
                  <span class="airline_code">{{ item.content.airline }}</span>
                </div>
                <div>{{ item.content.destination }}</div>
                <template v-if="item.icon == 'HOT'">
                  <i class="el-icon-eft-hot iconfont"></i>
                </template>
                <template v-if="item.icon == 'NEW'">
                  <i class="el-icon-eft-new1 iconfont"></i>
                </template>
              </div>
              <div class="subtitle" v-if="item.content.productType == 'FLA'">
                <!-- {{$t('footer.sales')}} -->
                <span>
                  CNY￥
                  <b>{{ item.content.price }}</b> </span
                >/kg
              </div>
              <div class="subtitle" v-if="item.content.productType == 'PRO'">
                <!-- 明星航线 -->
                <span>
                  CNY￥
                  <b>{{ item.content.price }}</b> </span
                >/kg
              </div>
              <div class="subtitle" v-if="item.content.productType == 'NOR'">
                <!-- 热门产品 -->
                <span>
                  CNY￥
                  <b>{{ item.content.price }}</b> </span
                >/kg
              </div>
              <div class="title_bottom">
                <div
                  class="product_tips title_bottom_detail"
                  v-if="!!item.content.productTitle"
                >
                  {{ item.content.productTitle }}
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="4" class="tc" v-if="item.type == 'ACTIVITY'">
            <a :href="item.url" target="_blank">
              <div class="title">
                <span>{{ item.content.title }}</span>
                <template v-if="item.icon == 'HOT'">
                  <i class="el-icon-eft-hot iconfont"></i>
                </template>
                <template v-if="item.icon == 'NEW'">
                  <i class="el-icon-eft-new1 iconfont"></i>
                </template>
              </div>
              <div class="subtitle">{{ item.content.subtitle }}</div>
            </a>
          </el-col>
          <el-col :span="1" v-if="index != 4">
            <div class="cutline"></div>
          </el-col>
        </template>
      </el-row>
      <el-row class="sub">
        <div class="tc title fl">{{ $t("home.plate") }}</div>
        <div class="fl s-container">
          <div class="v-animation clearfix" :style="vAnimationStyle">
            <div class="item fl" v-for="item of dataSource5" :key="uuid">
              {{ item.Departure }} --- {{ item.Destination }}:
              {{ item.InboundGrossWeight }}KG,{{ item.InboundPieces }}QTY,{{
                item.InboundVolumn
              }}CBM
            </div>
            <div class="item fl" v-for="item of dataSource5" :key="uuid">
              {{ item.Departure }} --- {{ item.Destination }}:
              {{ item.InboundGrossWeight }}KG,{{ item.InboundPieces }}QTY,{{
                item.InboundVolumn
              }}CBM
            </div>
          </div>
        </div>
      </el-row>
    </el-card>
    <div class="overLayer hidden" :style="overLayerStyle" v-if="showOverLayer">
      <div class="bg fl"></div>
      <div class="o-main-container">
        <div class="o-main fl">
          <div class="bg1 fl"></div>
          <div class="o-content fl">
            <el-row class="text1">{{ $t("home.tips.p1") }}</el-row>
            <el-row class="text2">{{ $t("home.tips.p2") }}</el-row>
            <el-row class="text3">{{ $t("home.tips.p3") }}</el-row>
            <el-row class="text3"
              >{{ $t("home.tips.p4") }}<b>{{ $t("home.tips.p5") }}</b
              >，</el-row
            >
            <el-row class="text3">{{ $t("home.tips.p6") }}</el-row>
            <el-row class="text4">
              <el-button @click="gotoQuestionPage()">{{
                $t("home.tips.p7")
              }}</el-button>
            </el-row>
            <el-row class="text5">{{ $t("home.tips.p8") }}</el-row>
          </div>
          <i class="el-icon-circle-close" @click="closeQuestionOverLayer()"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css" lang="less" scoped="true">
@import "~@/assets/css/view/index.css";
</style>
<script type="babel">
import AirportSelection from "@/components/airportSelection/index.vue";
import YC_REQUEST_HANDLER from "@/api/request.js";
import UTILS from "@/utils/utils.js";
import DBUtils from "@/utils/dbUtils.js";
import LOKIJS from 'lokijs';
import URLSearchParams from 'url-search-params';
import x2js from 'x2js';
const X2JS = new x2js();
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
    computed: {
	    ...mapState({
            token: state => state.token,
	    }),
	    ...mapGetters({
	        login: 'checkLogin',
	    })
	},
    components: {
        AirportSelection,
    },
    data: function() {
        return {
            overLayerStyle: {},
            showOverLayer: true,
            popBarDataSource: [],
            menuIndex: "1",
            weight: "",
            volume: "",
            chargeWeight: "",
            proportion: "",
            goodsType: "",
            departureSelectionFocusState: true,
            destinationSelectionFocusState: false,
            goodsTypeArray: [
                {
                    label: "All",
                    value: null
                },
                {
                    label: "Bulk",
                    value: 1
                },
                {
                    label: "Tray",
                    value: 2
                }
            ],
            airportDB: [],
            cityDB: [],
            departure: "",
            destination: "",
            cityListDestination: [],
            cityListDeparture: [],
            orderNo: "",
            dataSource5: [],
            value: "",
            vAnimationStyle: {},
            uuid:'',
            yunModel: this.$route.meta.yunModel,
            emptyArray: [],
        };
    },
    mounted: async function() {
        this.airportDB = await DBUtils.getDBPorts()
        this.cityDB = await DBUtils.getDBCitys()
        this.uuid=UTILS.uuid()
        this.loadPopBarDataSource();
        this.loadDataSource5()
        var _this = this;
        if (window.location.hash) {
            window.location.href = window.location.hash; //定位到锚点
        }
        var screenHeight = window.document.body.clientHeight;
        this.overLayerStyle = {
            width: window.document.body.clientWidth + "px",
            height: screenHeight + "px",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 4000
        };
        this.showOverLayer = !window.localStorage.getItem("hideIndexOverLayer");
    },
    methods: {
        closeQuestionOverLayer: function() {
            this.showOverLayer = false;
            window.localStorage.setItem("hideIndexOverLayer", true);
        },
        menuSelectHandler: function(tab, event) {
            var idx = tab.index;
            if (idx == 1) {
                this.$router.push('/product/starList' );
            }
        },
        beforeMenuSelectHandler: function(activeName) {
            if (activeName != 1 && activeName != 3) {
                return false;
            }
            return true;
        },
        weightChangeHandler: function(event) {
            if (event != this.weight) {
                this.weight = event;
            }
            this.updateChargeWeight();
            this.updateProportion();
        },
        volumeChangeHandler: function(event) {
            if (event != this.volume) {
                this.volume = event;
            }
            this.updateChargeWeight();
            this.updateProportion();
        },
        updateChargeWeight: function() {
            var totalGrossWeight = this.weight;
            var volume = this.volume;
            if (!totalGrossWeight) totalGrossWeight = 0;
            if (!volume) volume = 0;
            var volumeWeight =Math.ceil((volume * 1000000) / 6000)
            this.chargeWeight = Math.max(totalGrossWeight, volumeWeight);
            if (this.chargeWeight == 0) {
                this.chargeWeight = "";
            }
        },
        updateProportion: function() {
            var density = parseInt(parseFloat(this.weight) / parseFloat(this.volume));
            if (density) {
                this.proportion = density;
            } else {
                this.proportion = "";
            }
        },
        departureSelectionBlurHandler: function() {
            this.departure = "";
        },
        destinationSelectionBlurHandler: function() {
            this.destination = "";
        },
        gotoProductionSearchPage: function() {
            this.$router.push({
                name:'ProductQueryPage',
                query:{
                    departure: this.departure,
                    destination: this.destination,
                }
            })
        },
        gotoTrailPage: function() {
            this.$bus.emit("toTrailPage", this.orderNo);
        },
        loadDataSource5: function() {
            //轮播图右侧的置顶拼货
            var serviceXml = {
                Service: {
                    ServiceURL: "OrderInfo",
                    ServiceAction: "UserWebQueryScroll",
                    ServiceData: {
                        PageSize: "60"
                    }
                }
            };
            var _this = this,
            successCallBack = function(response) {
                if (!!response.OrderInfos && !!response.OrderInfos.OrderInfo) {
                var items = response.OrderInfos.OrderInfo;
                if (items.constructor === Array) {
                    _this.dataSource5 = items;
                } else {
                    _this.dataSource5.push(items);
                }
                if (_this.dataSource5.length > 30) {
                    _this.dataSource5.splice(30);
                }
                var length = _this.dataSource5.length;
                var width = " " + 280 * 2 * length + "px";
                var animation = "vLoop " + 4 * length + "s linear infinite";
                // console.log(width)
                _this.vAnimationStyle = {
                    width: width,
                    animation: animation
                };
                //不可以再css中默认赋值时间
                }
                // console.log(_this.dataSource5)
            },
            failCallBack = function(err) {};
            _this.loadDataSource(serviceXml, successCallBack, failCallBack);
        },
        loadDataSource: function(serviceXml, successCallBack, failCallBack) {
            var xml_content = X2JS.js2xml(serviceXml);
            var params = new URLSearchParams();
            params.append(
                "serviceXml",
                xml_content.replace(/[\r\n]/g, "").replace(" ", "")
            );
            YC_REQUEST_HANDLER.PostXmlWithoutCheckToken(
                "/eFreightHttpEngine",
                params,
                function(response, pIdx, pCnt) {
                successCallBack(response);
                },
                function(err) {
                failCallBack();
                }
            );
        },
        loadPopBarDataSource: function() {
            var _this = this;
            var params = {
                areaCode: 'ALL'
            };
            var url = "/api/setting/home/list";
            var successCallBack = function(response) {
                _this.popBarDataSource = []
                var list = response.settingHomeList;
                if (list.length > 5) {
                    list.splice(5);
                }
                var length = parseInt(list.length);
                for(var i = 0,len=list.length; i < len; i++) {
                    var unit = list[i];
                    unit.content = JSON.parse(unit.content);
                    var type = unit.type;
                    if (type == "PRODUCT") {
                        var pType = unit.content.productType;
                        var productCode = unit.content.productCode;
                        var priceCode = unit.content.priceCode;
                        var departure = unit.content.departure;
                        var destination = unit.content.destination;
                        unit.url ={
                            name: 'ProductDetailPage',
                            query:{
                                productcode: productCode,
                                pricecode: priceCode,
                                productType: pType,
                                departure: departure,
                                destination: destination
                            }
                        }
                    }
                    _this.popBarDataSource.push(unit);
                }
            };
            var failCallBack = function(errcode, errmessage) {
                _this.$bus.emit("common-error-handler", errmessage);
            };
            YC_REQUEST_HANDLER.postQuery(url, params, successCallBack, failCallBack);
        },
        openKF5Support: function() {
            if (window.KF5SupportBoxAPI) {
                window.KF5SupportBoxAPI.open();
            } else {
                window.open("https://efreight.kf5.com/kchat/1009507", "_blank");
                // window.KF5SupportBoxAPI.setAgents([4084194, 5976120], true); //指定客服
            }
        },
        gotoFlightListPage: function() {
            this.$router.push({name:'ProductQueryPage'})
        },
        gotoServicePage: function() {
            if (window.KF5SupportBoxAPI) {
                window.KF5SupportBoxAPI.open();
            } else {
                window.open("https://efreight.kf5.com/kchat/1009507", "_blank");
                // window.KF5SupportBoxAPI.setAgents([4084194, 5976120], true); //指定客服
            }
        },
        gotoServiceDetailPage: function(type) {
            var url = "";
            switch (type) {
                case 2:
                url = "//baidu.com";
                break;
            }
            if (url) {
                this.$router.push(url)
            }
        },
        updateDeparture: function(departure) {
            this.departure = departure;
        },
        updateDestination: function(destination) {
            this.destination = destination;
        },
        focusDestination: function() {
            this.destinationSelectionFocusState = true;
            // this.departureSelectionFocusState = false
        },
        focusDeparture: function() {
            // this.destinationSelectionFocusState = false
        },
        departureSelectionBlur: function() {
            this.departureSelectionFocusState = false;
        },
        destinationSelectionBlur: function() {
            this.destinationSelectionFocusState = false;
        }
    }
};
</script>
